var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZillowTransactionsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3ceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20956,
    stopColor: "#71a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#006aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0040ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.64124,52.42737l-7.13489-5.1673c-.10455-.07574-.21777-.13354-.32684-.20013v-4.19409l-21.8797-18.25482-21.92487,18.25482v8.16895c6.79626-4.26196,22.49713-10.86035,29.61182-12.73212h.00214c.22162-.05804.32269.02582.45392.18073.75299.89502,3.17981,4.01459,3.84027,4.86871.09772.12268.07751.30133-.04517.39905-.00421.00336-.00854.00659-.01294.0097-4.89227,4.0296-10.33527,9.7287-13.36877,13.81213-.06451.08606-.01074.09253.03229.07312,1.58295-.7193,3.81134-1.56738,6.29852-2.43085v3.22205c0,1.82562,1.03656,3.39734,2.54114,4.20819-6.45483,2.13599-13.31458,4.75354-17.53992,7.05072-.15057.10327-.35498.07318-.47327-.07312l-4.08551-5.13544c-.11401-.13983-.12262-.21301.02148-.44104,3.15613-4.88586,9.59741-12.48688,13.70654-15.70752.07318-.05811.05377-.10974-.03223-.07965-4.28131,1.47589-16.44531,6.99213-20.94818,9.6814v17.44806h29.23346l4.2616,3.08643c.82538.59772,1.79761.91357,2.81171.91357,2.02832,0,3.76691-1.26379,4.46924-3.04504h5.23981c2.64594,0,4.79858-2.15265,4.79858-4.79858v-4.24719c0-2.06519-1.31854-3.81409-3.15234-4.48926l3.60205-2.6087c1.24237-.8999,1.98395-2.35278,1.98389-3.88654s-.74164-2.98657-1.98383-3.88623ZM65.89307,59.33136v-.09546h.00006v.09546h-.00006ZM65.89313,53.39154h-.00006v-2.24506c0-.00037.00018-.00055.00018-.00092,0,.00031-.00012.00061-.00012.00092v2.24506Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZillowTransactionsScraper);
export default __webpack_public_path__ + "static/media/zillow-transactions-scraper.089f56a915813164ac0e329a15bd6a26.svg";
export { ForwardRef as ReactComponent };